import React from "react";
import { FlickityOptions } from "react-flickity-component";
import "flickity/dist/flickity.min.css";
import ControlCarousel from "./ControlCarousel";
import ImageGallery from "./ImageGallery";
import GalleryWrapper from "./GalleryWrapper";
import { BasicImage } from "@lib/utils/sanityImageToBasicImage";

interface ProductImageGalleryProps {
  images: BasicImage[];
  isSticky?: boolean;
  wrapperClassName?: string;
  flicketyOptions?: FlickityOptions;
  showCaptions?: boolean;
  emptyMessage?: string;
}

class ProductImageGallery extends React.Component<ProductImageGalleryProps> {
  render() {
    const { images, wrapperClassName, isSticky, flicketyOptions, showCaptions, emptyMessage } =
      this.props;

    return (
      <GalleryWrapper
        isSticky={isSticky}
        wrapperClassName={wrapperClassName}
        render={({
          registerControlCarousel,
          registerMainCarousel,
          handleSelect,
          isReady,
          selectedIndex,
          mainCarouselEvents,
          controlCarouselEvents,
        }) => {
          return (
            <>
              {images.length === 0 && <div>{emptyMessage} </div>}
              <ImageGallery
                key={`ig-${images.map(image => image.assetRef)}`}
                images={images}
                registerGallery={registerMainCarousel}
                showCaptions={showCaptions}
                flicketyOptions={flicketyOptions}
                flicketyEvents={mainCarouselEvents}
              />
              <ControlCarousel
                key={`cc-${images.map(image => image.assetRef)}`}
                images={images}
                isMainImageReady={isReady}
                registerControlCarousel={registerControlCarousel}
                handleSelect={handleSelect}
                selectedIndex={selectedIndex}
                flicketyEvents={controlCarouselEvents}
              />
            </>
          );
        }}
      />
    );
  }
}

export default ProductImageGallery;
